import axios from "axios";

const userAPI = axios.create({
    baseURL: "/api/user",
    headers: {
        "Content-Type": "application/json",
    },
    timeout: 5000,
    withCredentials: true,
});

export const getPreferences = async () => {
    const response = await userAPI.get("/preferences/");
    return response.data;
};

export const updatePreferences = async (data) => {
    const response = await userAPI.patch("/preferences/", data);
    return response.data;
};

export default userAPI;
